/**
 * Parses a taskID in format package/task into an object
 * @param taskID
 */
export const parseTaskID = (taskID: string) => {
    const [packageID, taskIndex] = taskID.split('/');
    return {
        packageID,
        taskIndex: parseInt(taskIndex),
    };
};

/**
 * Parses a taskItemID in format package/task/taskItem into an object
 * @param taskItemID
 */
export const parseTaskItemID = (taskItemID: string) => {
    const [packageID, taskIndex, taskItemIndex] = taskItemID.split('/');
    return {
        packageID,
        taskIndex: parseInt(taskIndex),
        taskItemIndex: parseInt(taskItemIndex),
    };
};

/**
 * Parses a taskTitle to extract the task number from the text.
 */
export const parseTaskTitle = (
    title: string,
): { taskTitleNumber?: number; taskTitleText: string } => {
    const match = title.match(/^(\d+)\. (.+)$/);
    if (match) {
        return {
            taskTitleNumber: parseInt(match[1]),
            taskTitleText: match[2],
        };
    }
    return {
        taskTitleText: title,
    };
};
